import styled from '@emotion/styled'
import { Flex } from 'theme-ui'

import media from '../../../common/MediaQueries'

const SectionContainerStyled = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  flex-direction: column;

  @media ${media.tablet} {
    flex-direction: row;
  }
`

const SectionContentStyled = styled(Flex)`
  flex-direction: column;
  width: 100%;
  margin-bottom: 1.25rem;
  order: 1;

  @media ${media.tablet} {
    width: 46%;
    margin-bottom: 0;
    order: 2;

    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-right: 9.75rem' : 'padding-left: 9.75rem')};
  }
`

const SectionMediaStyled = styled(Flex)`
  position: relative;
  width: 20rem;
  margin-bottom: 3.5rem;
  order: 2;

  @media ${media.phone} {
    width: auto;
    height: 28.1875rem;
  }
  @media ${media.tablet} {
    width: 54%;
    margin-bottom: 0;
    order: 1;
  }
`
const SectionMobileCtaStyled = styled(Flex)`
  justify-content: center;
  width: 100%;
  order: 3;
`

const SectionMarkStyled = styled(Flex)`
  position: absolute;
  right: 0;
  top: 0;
  width: 3.75rem;
  img {
    width: 100%;
  }
  @media ${media.phone} {
    width: 6.25rem;
  }
  @media ${media.tablet} {
    width: 7.625rem;
  }
`

export { SectionContainerStyled, SectionContentStyled, SectionMediaStyled, SectionMobileCtaStyled, SectionMarkStyled }
